<template>
    <activation-task-custom-delivery-provider
        v-slot="{
            brief,
            contact,
            step,
            task,
            deliverable,
            errorMessage,
            isLoading,
            deliverStoryUrl,
            deliverInsightsUrl,
            isDeliverableComplete,
            handleInsightsFileChange,
            handleStoryFileChange,
            deliverableHasInsights,
            handleStartConnection,
            handleError
        }"
        style="height: 100%"
    >
        <activation-custom-task-delivery-view
            :brief="brief"
            :contact="contact"
            :step="step"
            :task="task"
            :deliverable="deliverable"
            :is-loading="isLoading"
            :error-message="errorMessage"
            :deliver-story-url="deliverStoryUrl"
            :deliver-insights-url="deliverInsightsUrl"
            :is-deliverable-complete="isDeliverableComplete"
            :deliverable-has-insights="deliverableHasInsights"
            @story-file-change="handleStoryFileChange"
            @insights-file-change="handleInsightsFileChange"
            @start-connection="handleStartConnection"
            @error="handleError"
        />
    </activation-task-custom-delivery-provider>
</template>

<script>
    import ActivationCustomTaskDeliveryView from '../data-views/activation-briefs/partials/tasks/ActivationCustomTaskDeliveryView.vue';
    import ActivationTaskCustomDeliveryProvider from '../providers/activation-brief-steps/ActivationTaskCustomDeliveryProvider.vue';

    export default {
        name: 'TaskDeliveryCustomRouterView',
        components: {
            ActivationTaskCustomDeliveryProvider,
            ActivationCustomTaskDeliveryView
        }
    };
</script>
